import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAppStore } from '@/store';
import { CHAIN_LIST } from '@/config/chainConfig';
import { Check } from 'lucide-react';
import { SupportedChain, useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default () => {
  const { chainInfo, setChainInfo } = useAppStore();
  const { switchChain, chain } = useBoomWallet();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const targetChainInfo = CHAIN_LIST.find((item) => item.chain === chain) || CHAIN_LIST[0];
    if (chainInfo?.chain !== targetChainInfo.chain) {
      localStorage.setItem('chain', targetChainInfo.chain);
      setChainInfo(targetChainInfo);
      navigate('/');
    }
  }, [chain, pathname]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex items-center justify-center">
          <img src={chainInfo?.icon} className="size-[24px]" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[185px]">
        <DropdownMenuGroup>
          <DropdownMenuSub>
            {CHAIN_LIST.map((item) => {
              return (
                <DropdownMenuItem
                  className="flex justify-between items-center"
                  key={item.label}
                  onClick={() => {
                    switchChain && switchChain(item.chain as SupportedChain);
                  }}
                >
                  <div className="flex gap-x-[10px] items-center">
                    <img src={item.icon} className="size-[24px]" />
                    <span>{item.label}</span>
                  </div>
                  {chain == item.chain && <Check />}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuSub>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
